import { useEffect } from 'react';
import Hotjar from '@hotjar/browser';

const HotjarInit = () => {
  useEffect(() => {
    const siteId = 6478697;
    const hotjarVersion = 6;

    Hotjar.init(siteId, hotjarVersion);
  }, []);

  return null; // This component doesn't render anything
};

export default HotjarInit; 